import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import LoaderModal from "./modals/loaderModal";
import { errorToast, successToast } from "./toast";
import { sendContactRequest } from "./contactApi";

const ContactUs = ({ }) => {
    const [loading, setloading] = useState(false)
    const validationSchema = Yup.object({
        name: Yup.string().required("Name is required"),
        email: Yup.string()
            .email("Invalid email address")
            .required("Email is required"),
        mobile: Yup.string()
            .matches(/^\d{10}$/, "Phone number must be 10 digits")
            .required("Phone number is required"),
        message: Yup.string().required("Message is required"),
    });

    const initialValues = {
        name: "",
        email: "",
        mobile: "",
        message: "",
        type: "Contact (INVETIX POS)"
    };

    const handleSubmit = async (values, { resetForm }) => {
        setloading(true);
        try {
            const response = await sendContactRequest(values);

            if (response?.status === 200) {
                successToast("Request sent successfully!");
            } else {
                const errorMessage = response?.data?.message || "Something went wrong!";
                errorToast(errorMessage);
            }
        } catch (error) {
            console.error("Error occurred:", error);
            errorToast(error?.response?.data?.message || "Failed to submit request. Please try later.");
        } finally {
            setloading(false);
            resetForm();
        }
    };

    return (
        <section className="bg-lightGray py-8 overflow-x-hidden" id="contact">
            <div className="bg-white p-6 rounded-lg w-full max-w-md sm:max-w-lg md:max-w-2xl lg:max-w-3xl xl:max-w-4xl mx-auto"
                data-aos="fade-left"
                data-aos-duration="1500"
            >
                <h2 className="text-xl font-bold text-primary mb-4 text-center">Contact Us</h2>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    <Form className="flex flex-col items-center text-start">
                        <div className="mb-4 w-full">
                            <label className="block text-sm font-medium text-gray-700">
                                Name
                            </label>
                            <Field
                                name="name"
                                type="text"
                                className="input-field w-full"
                                placeholder="Enter your name"
                            />
                            <ErrorMessage
                                name="name"
                                component="div"
                                className="text-red-500 text-sm mt-1"
                            />
                        </div>
                        <div className="mb-4 w-full">
                            <label className="block text-sm font-medium text-gray-700">
                                Email
                            </label>
                            <Field
                                name="email"
                                type="email"
                                className="input-field w-full"
                                placeholder="Enter your email"
                            />
                            <ErrorMessage
                                name="email"
                                component="div"
                                className="text-red-500 text-sm mt-1"
                            />
                        </div>
                        <div className="mb-4 w-full">
                            <label className="block text-sm font-medium text-gray-700">
                                Phone
                            </label>
                            <Field
                                name="mobile"
                                type="text"
                                className="input-field w-full"
                                placeholder="Enter your phone number"
                            />
                            <ErrorMessage
                                name="mobile"
                                component="div"
                                className="text-red-500 text-sm mt-1"
                            />
                        </div>
                        <div className="mb-4 w-full">
                            <label className="block text-sm font-medium text-gray-700">
                                Message
                            </label>
                            <Field
                                as="textarea"
                                name="message"
                                className="input-field w-full h-24 resize-none"
                                placeholder="Enter your message"
                            />
                            <ErrorMessage
                                name="message"
                                component="div"
                                className="text-red-500 text-sm mt-1"
                            />
                        </div>
                        <button
                            type="submit"
                            className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 w-full sm:w-auto"
                        >
                            Submit
                        </button>
                    </Form>
                </Formik>
                {loading && <LoaderModal />}
            </div>
        </section>
    );
};

export default ContactUs;